import Explorer from 'views/LockTools/Explorer'

const Page = () => <Explorer />
// Readable on every wallet chain: the explorer only reads data. Actions that need BNB Smart Chain ask for it where they are taken.
Page.chains = []

export default Page
